var $headerH = $('.header').outerHeight() + 2;

$(document).ready(function(){

	if ($(window).width() > 767) {
		var stickyH = $('.sticky__wrapper').outerHeight();
		$('.sticky__wrapper').next().css({
			'margin-top': -stickyH
		});		
	}

	// -- active element --
	$(window).on('scroll orientationchange', function() {
    var scrollTop = $(this).scrollTop();

		$('.card--services').each(function() {
			var elTop = $(this).offset().top;
			var elH = elTop + $(this).outerHeight();
			if (scrollTop > (elTop - $headerH) && scrollTop < elH) {
				var activeId = $(this).attr('id');
				$('.anchors li').removeClass('active');
				$('.anchors li').find('.'+activeId).parent('li').addClass('active');
			}
		});
	});

});